<div class="margin">
	<others-instruments [(form)]="form"></others-instruments>
</div>